export const setTenantsList = (state, tenantsList) => {
    state.tenantsList = tenantsList
}
